<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
          <h4 slot="header" class="card-title cd-breadcrumb-title">
            <i class="icon-svg icon-building"></i>
            <router-link to="/admin/contacts" class="cd-breadcrumb-title__link">{{$t('listado_companias')}}</router-link>
            <span class="cd-breadcrumb-title__sep">/</span>
            <span class="cd-breadcrumb-title__current">{{ id ? $t('Editar compañía') : $t('Nueva compañía') }}</span>
          </h4>
          <form>
            <div class="row">
              <div class="col-md-6">
                <base-input type="text" :label="$t('Nombre')" :placeholder="$t('Nombre')"  v-model="name">
                    <template v-slot:textError v-if="$v.name.$error && !$v.name.required">{{ $t("Campo_requerido") }}</template>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input type="text" :label="$t('Apellido')" :placeholder="$t('Apellido')"  v-model="lastname">
                  <!-- <template v-slot:textError v-if="$v.lastname.$error && !$v.lastname.required">{{ $t("Campo_requerido") }}</template> -->
                </base-input>
              </div>
            </div>
             <div class="row">
              <div class="col-md-6">
                <base-input type="text" :label="$t('document')" :placeholder="$t('document')"  v-model="document">
                <template v-slot:textError v-if="$v.document.$error && !$v.document.required">{{ $t("Campo_requerido") }}</template>
                </base-input>
              </div>

            </div>
            <div class="row">
              <div class="col-md-6">
                <base-input type="text" :label="$t('Email')" :placeholder="$t('Email')"  v-model="email">
                    <template v-slot:textError v-if="$v.email.$error && !$v.email.required">{{ $t("Campo_requerido") }}</template>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input type="text" :label="$t('phone')" :placeholder="$t('phone')"  v-model="phone"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <base-input type="text" :label="$t('Direccion')" :placeholder="$t('Direccion')" @clickEvent="onSearchAdrress" :addonRightIcon="'fas fa-search'" :addonDisabled="!address || !address.trim()"  v-model="address">
                  <template v-slot:textError v-if="error_server">{{ error_server }}</template>
                  <template v-slot:textInfo >{{ full_address }}</template>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                  <base-input type="text" :label="$t('Estado')" :placeholder="$t('Estado')"  v-model="state"></base-input>
              </div>
              <div class="col-md-4">
                  <base-input type="text" :label="$t('Ciudad')" :placeholder="$t('Ciudad')"  v-model="city"></base-input>
              </div>
              <div class="col-md-4">
                  <base-input type="text" :label="$t('zipcode')" :placeholder="$t('zipcode')"  v-model="zipcode"></base-input>
              </div>
            </div>
            </form>
            <div class="row mb-4 mt-2">
                <div class="col-12">
                    <button type="button" @click="submit()" class="btn cd-btn-save">
                      {{$t("Guardar")}}
                    </button>
                </div>
            </div>
            <!-- <div class="row" v-if="tableData.length > 0">
                <div class="col-12 mb-2 ml-2 ">
                    <h5 class="text-secondary text-uppercase">{{$t("Solicitudes")}}</h5>
                </div>
                <div class="col-12">
                 <l-table class="mb-2"
                            :columns="table.columns"
                            :section="tableSection"
                            :urlDownload="urlDownload"
                            :urlEmail="urlEmail"
                            @send_contract="onSendContract"
                            @upload_contract="onShowModal"
                            :data="tableData">
                    </l-table>
                </div>
            </div> -->
            <div class="row" v-if="tableAttachment.length > 0" >
                <div class="col-12 mt-4 ml-2">
                    <h5 class="text-secondary text-uppercase">{{$t("Adjuntos")}}</h5>
                </div>
                <div class="col-12">
                 <l-table class="mb-2"
                            :columns="table.columnsAttachment"
                            :urlDownload="urlDownloadAttachment"
                            :data="tableAttachment">
                    </l-table>
                </div>
            </div>
            <div class="row" v-if="id">
                <div class="col-12 d-flex justify-content-between align-items-center">
                    <h6 class="cd-section-title mb-0">{{$t("Usuarios")}}</h6>
                    <button type="button" class="btn btn-add-outline btn-sm" @click="onShowModalUser">
                      <i class="icon-svg icon-plus"></i> {{$t("nuevo_usuario")}}
                    </button>
                </div>
                <div class="col-12" v-if="users.length > 0">
                 <l-table class="mb-5"
                            :columns="table.columnsUser"
                            :can-delete="canDeleteUser"
                            @deleteEvent="onDeleteUser"
                            @editEvent="onEditUser"
                            :data="users">
                    </l-table>
                </div>
            </div>
            <div class="clearfix"></div>
        </card>
        </div>
      </div>
    </div>
    <modal v-if="showModalMaxUser" :showButton="false" :showClose="true" @close="onCloseModalMaxUser" :title="$t('alert_max_users')" :showBtnAccept="false" :showBtnCancel="false" :size="'md'" >
      <div>
        <p>Tiene contratados un máximo de <strong>{{ this.max_users }}</strong> usuarios en su licencia CleverDocs.</p>
        <p>Para crear un nuevo usuario debería contratar más usuarios pinchando <a target="_blank" href="https://www.cleverauditbs.com/contacto">aquí</a> o póngase en contacto con nosotros en:
        </p>
        <div class="row">
          <div id="contact_img" class="col-4">
            <img src="https://legalnet.cleverbsolutions.com/img/logo_bajo.65eecd8e.png" class="logoIndex" width="100%" alt="">
          </div>
          <div class="col-8">
            <p class="colap2">
              <b>CleverBusiness Solutions SL</b><br>
              <a style="font-size:17px;" href="mailto:contacto@cleverbsolutions.com">contacto@cleverbsolutions.com</a><br>
              Travesera de Gracia, 16 entlo. A<br>
              08021 Barcelona<br>
              Tel. <a href="tel:934147283">93 414 72 83</a><br>
            </p>
          </div>
        </div>
      </div>
    </modal>
    <modal class="cd-modal" classContent="cd-modal-body-tall" v-if="showModalUser" :showClose="true" :btnAcceptText="$t('Guardar')" :btnCancelText="$t('Cancelar')" @close="onCloseModalUser" :title="userModalTitle" @accept="onCreateUser" :showBtnCancel="true" :size="'xlg'" >
              <base-input type="text" :label="$t('Nombre')" :placeholder="$t('Nombre')" v-model="name_user"/>
              <base-input type="text" :disabled="!isNew" :label="$t('Email')" :placeholder="$t('Email')" v-model="email_contact"/>
              <div class="row">
                <div class="col-md-6">
                  <base-input type="password" :label="$t('Password')" :placeholder="$t('Password')" v-model="password"/>
                </div>
                <div class="col-md-6">
                  <base-input type="password" :label="$t('Repeat Password')" :placeholder="$t('Repeat Password')" v-model="repassword"/>
                </div>
              </div>
              <!-- Editing: both boxes empty means "leave the password as it is", so the
                   rule is spelled out instead of leaving an empty field looking wrong. -->
              <p class="cd-user-password-hint" v-if="!isNew">{{$t('password_keep_hint')}}</p>
              <div class="row">
                <div class="col-md-6">
                  <base-input type="text" :label="$t('user_position')" :placeholder="$t('user_position')" v-model="position"/>
                </div>
                <div class="col-md-6">
                  <base-select :label="$t('Rol')" :placeholder="$t('Rol')" v-model="rol_id" :items="roles">
                    <!--<template v-slot:textError v-if="$v.rol_id.$error">
                      <span v-if="!$v.rol_id.required" >{{$t('Campo_requerido')}}</span>
                    </template>-->
                  </base-select>
                </div>
              </div>
            <!--<input  v-if="!isNew" :checked="active" type="checkbox" v-model="active" :value="active" id="chk_active">
            <label for="chk_active">ACTIVADO</label>-->
            <base-checkbox v-if="!isNew" id="chk_active" style="margin-top: 10px;" v-model="active">{{$t('Activado')}}</base-checkbox>

              <hr v-if="checkedFolder.length > 0 && !isAdminRole" >
              <div v-if="checkedFolder.length > 0 && !isAdminRole" class="bg-light p-1 d-flex">
                <div class="py-1 px-2 m-1 boder-dashed text-uppercase" v-for="(row, index) in checkedFolder" v-bind:key="index">
                    <span><i class="icon-svg icon-folder-filled folder-icon mr-2"></i>{{row.name}}</span>
                  <i class="fa fa-times" @click="onDeleteFolder(row)"></i>
                </div>
              </div>
              <div class="contentRoot" :class="{ 'contentRoot--locked': isAdminRole }">
                <label class="control-label">{{$t("directory")}} </label>
                <!-- An administrator reaches the whole tree from INICIO: there is
                     nothing to pick, so the tree stays visible but inert. -->
                <p class="cd-folder-tree-hint" v-if="isAdminRole">
                  <i class="icon-svg icon-folder-filled folder-icon mr-2"></i>{{$t("admin_folders_all")}}
                </p>
                <ejs-treeview id='treeview' v-if="show" ref='treeview' :autoCheck="false" :disabled="isAdminRole" @nodeChecked="onCheckedNode" :checkedNodes='checkedNodes' :fields="fields" :showCheckBox='true'></ejs-treeview>
              </div>
              <div v-if="errorUser">
                  <span class="invalid-feedback py-2">{{errorUser}}</span>
              </div>
      </modal>
      <div>
        <vue-easy-lightbox
            escDisabled
            moveDisabled
            :visible="visible"
            :imgs="imgs"
            :index="index"
            @hide="handleHide"
          ></vue-easy-lightbox>
      </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { apiCallSingle } from '../../mixins';
  const tableColumns = ['request_type', 'insolvency', 'honoraries', 'created_at' , 'status', 'options', 'download'];
  import { required } from 'vuelidate/lib/validators';
  import Modal from "@/components/Modal.vue";
  import { handleLimitError } from '../../utils/limitErrors';

  export default {
    mixins: [apiCallSingle],
    computed : {
      ...mapGetters({
        loggedUser : 'login/user'
      }),
      // The user modal is shared by the create and the edit flows.
      userModalTitle ()
      {
        return this.isNew ? this.$t("create_user") : this.$t("edit_user");
      },
      // An administrator is not given a selection of folders: they reach the whole
      // tree from INICIO, so the directory area of the modal is locked for them.
      isAdminRole ()
      {
        return this.rol_id == this.ADMIN_ROL_ID;
      }
    },
    data () {
      return {
        // roles.id of "Administrador", and the folder standing for INICIO.
        ADMIN_ROL_ID : 1,
        ROOT_FOLDER_ID : "0",
        total_users: 0,
        imgs: '',  // Img Url , string or Array of string
        visible: false,
        index: 0,   // default: 0
        position : null,
        active : null,
        endpoint  : "contacts",
        tableSection : "/admin/mediation",
        section   : "admin/contacts",
        urlDownload : "mediation/download/",
        urlDownloadAttachment : "document/download/",
        urlEmail    : "mediation/send_contract/",
        name      : null,
        lastname  : null,
        phone     : null,
        email     : null,
        message   : null,
        document  : null,
        max_users : null,
        is_primary : null,
        city      : null,
        address   : null,
        zipcode   : null,
        state     : null,
        full_address : null,
        showModal : false,
        showModalUpload : false,
        request_type_id : null,
        servicesTypes : [],
        tableData : [],
        error_server : null,
        files : null,
        password : null,
        repassword: null,
        showModalUser : false,
        showModalMaxUser: false,
        documents : [],
        errorUser : null,
        show : false,
        users : [],
        checkedNodes : [],
        // Guard: reprogramming the checked nodes from inside the nodeChecked
        // handler fires the event again, so the handler has to ignore itself.
        isSyncingNodes : false,
        email_contact : null,
        name_user   : null,
        rol_id   : null,
        roles   : [],
        user_id : null,
        isNew : true,
        folders : [],
        checkedFolder : [],
        fields:
        { 
          ataSource : {},
          id: 'id',
          parentID: 'parent_id',
          text: 'name',
          iconCss: 'icon',
          hasChildren: 'hasChild'
        },
        table:
        {
          columns: [...tableColumns],
          columnsAttachment :
          [
            'name',
            'created_at',
            'url'
          ],
          columnsUser :
          [
            'name',
            'user_position',
            'Email',
            'active',
            'actions_event'
          ]
        },
        tableAttachment : [],
        fileTypes : {
            'application/pdf' : 2,
            'image/jpeg'      : 4,
            'image/png'       : 4,
            'image/gif'       : 4,
            'video/mp4'       : 9,
            'audio/mpeg'      : 8,
            'audio/mp3'       : 8,
            'text/plain'      : 10,
            'application/zip' : 5,
            'application/x-zip-compressed' : 5,
            'application/msword' : 3,
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' : 3,
            'application/vnd.ms-powerpoint' : 6,
            'application/vnd.openxmlformats-officedocument.presentationml.presentation' : 6,
            'application/vnd.ms-excel'  : 7,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'  : 7,
            'text/csv'  : 7
        },
      }
    },
    props : {
      id : String
    },
    components : {
      Modal
    },
    created ()
    {
      this.onLoadRequestTypes ();
      this.onLoadFolders ();
      this.loadRoles();
    },
    watch :
    {
      // Turning somebody into an administrator drops the folders that were ticked:
      // they are neither saved nor used, and leaving them on screen under a locked
      // tree suggests the user is limited to them.
      rol_id ()
      {
        if (!this.isAdminRole) return;
        this.checkedNodes = [];
        this.checkedFolder = [];
        if (this.$refs.treeview) this.$refs.treeview.ej2Instances.uncheckAll ();
      }
    },
    validations ()
    {
        return {
          name : {
            required
          },
          document :  {
            required
          },
          email: {
            required
          }
        }
      },
  methods: {
    loadRoles(){
      this.$axios("/roles")
          .then((response) => {
            this.roles = response.data;
          })
    },
    showImg ()
    {
      this.visible = true
    },
    handleHide ()
    {
      this.visible = false
    },
    getFolderChecked (folder_ids)
    {
      this.checkedFolder = [];
      this.folders.forEach ((items) => {
        if (folder_ids.includes (String (items.id)))
        {
          this.checkedFolder.push (items) 
        }
      });     
    },
    loadData ()
    {
          this.name     = this.data.name;
          this.lastname = this.data.lastname;
          this.phone    = this.data.phone;
          this.email    = this.data.email;
          this.document = this.data.document;
          //this.max_users = this.data.max_users;
          this.is_primary= this.data.is_primary,
          this.city     = this.data.city
          this.address  = this.data.address,
          this.state    = this.data.state;
          this.zipcode  = this.data.zipcode;
          this.data.user_client.forEach ((item) => {
            item.user_position  = item.client_user.position;
          });   
          this.users    = this.data.user_client;
          this.data.mediations.forEach((item) => {
              item.request_type = "Mediación",
              item.honoraries = this.convertToCurrency(item.honoraries);
              item.insolvency = item.insolvency ? item.insolvency.name : '';
              item.status     = item.status ? item.status.name : '';
              item.download   = item.status_id > 1 ? true : false;
            });
          this.tableData = this.data.mediations;
          this.data.documents.forEach((item) => {
            item.created_at = this.$moment(item.created_at).format("DD/MM/YYYY"),
            item.url = true;
          });
          this.tableAttachment = this.data.documents;
      },
      onCloseModalMaxUser()
      {
        this.showModalMaxUser = false;
        this.email_contact = null;
        this.name_user   = null;
        this.rol_id   = null;
        this.position   = null;
        this.active   = null;
        this.user_id = null;
        this.isNew = true;
        this.checkedFolder = [];      },
      onCloseModalUser ()
      {
        this.showModalUser = false;
        this.email_contact = null;
        this.name_user   = null;
        this.rol_id   = null;
        this.position   = null;
        this.active   = null;
        this.user_id = null;
        this.isNew = true;
        this.checkedFolder = [];
      },
      // A logged in user must never be able to delete their own account: it
      // would log them out of an account that no longer exists and, when they
      // are the only administrator, leave the company without one.
      canDeleteUser (item)
      {
        return !this.loggedUser || item.id != this.loggedUser.id;
      },
      onDeleteUser (item)
      {
        if (!this.canDeleteUser (item)) return;
        this.$dialog.confirm ({
              title: this.$t("UserContact"),
              body: this.$t("UserContactText"),
              okText: this.$t("Aceptar"),
              cancelText: this.$t("Cancelar"),
          },
          { customClass: 'cd-dialog cd-dialog--danger' })
          .then (() => {
            this.$axios.delete ("/user/" + item.id)
            .then (() => {
              this.fetch ();
            })
          })
      },
      onDeleteFolder (row)
      {
        const treeview = this.$refs.treeview ? this.$refs.treeview.ej2Instances : null;
        if (!treeview) return;

        this.uncheckNodes (treeview, [String (row.id)]);
        this.getFolderChecked (treeview.checkedNodes);
      },
      // INICIO stands for the whole tree, so it cannot be held together with
      // individual folders: whichever of the two was ticked last wins.
      //
      // Only the tree instance is touched here. Writing this.checkedNodes back
      // would feed the :checkedNodes binding, which re-checks the nodes, which
      // fires this handler again: an endless round trip that freezes the modal.
      onCheckedNode (args)
      {
        if (this.isSyncingNodes) return;

        const treeview = this.$refs.treeview ? this.$refs.treeview.ej2Instances : null;
        if (!treeview) return;

        if (args && args.action === 'check')
        {
          const toggled = (args.data || []).map (node => String (node.id));

          if (toggled.includes (this.ROOT_FOLDER_ID))
          {
            this.uncheckNodes (treeview, treeview.checkedNodes.filter (id => id !== this.ROOT_FOLDER_ID));
          }
          else if (treeview.checkedNodes.includes (this.ROOT_FOLDER_ID))
          {
            this.uncheckNodes (treeview, [this.ROOT_FOLDER_ID]);
          }
        }

        this.getFolderChecked (treeview.checkedNodes);
      },
      uncheckNodes (treeview, ids)
      {
        if (!ids.length) return;

        // uncheckAll fires nodeChecked again, and the tree may do it on a later
        // tick, so the guard is lifted once the current one has drained.
        this.isSyncingNodes = true;
        treeview.uncheckAll (ids);
        setTimeout (() => { this.isSyncingNodes = false; }, 0);
      },
      getProperties ()
      {
          return {
              name    : this.name,
              lastname: this.lastname,
              email   : this.email,
              phone   : this.phone,
              document: this.document,
              //max_users: this.max_users,
              is_primary: this.is_primary,
              city    : this.city,
              address : this.address,
              state   : this.state,
              zipcode : this.zipcode
          }
      },
      convertToCurrency (amount)
      {
          return new Intl.NumberFormat ('de-DE', { style: 'currency', currency: 'EUR' }).format (amount)
      },
      onAccept ()
      {
        this.showModal = false;
        let data = {
          contact_id      : this.id,
          request_type_id : this.request_type_id,
          message :  this.message
        };
        this.$axios.post ("/request_services", data)
            .then ((response) => {
                this.$router.push ('/admin/procesar-solicitud/' + response.data.id);
            })
            .catch (() => {
              this.$dialog.alert ({
                    title: this.$t("NuevoTramite"),
                    body: this.$t("server_error")
                }, { customClass: 'cd-dialog cd-dialog--danger' })
            })
      },
      onShowModalUser ()
      {
        this.$axios ("/contacts")
            .then ((response) => {
              this.data = response.data;
              this.data.forEach ((element) => {
                if(element.is_primary){
                  this.max_users = element.max_users;

                  this.email_contact = this.email;
                  this.name_user = this.lastname ? this.name + " " + this.lastname : this.name;
                  this.password = null;
                  this.repassword = null;
                  this.position = null;
                  this.active   = null;
                  this.isNew = true;
                  this.checkedNodes = [];
                  this.checkedFolder = [];
                }
              });
            })
            .catch(() => {
              this.$store.dispatch ("isLoadingOff");
            });
        this.$store.dispatch ("isLoadingOn");
        this.$axios ("/user")
          .then ((response) => {
            this.data = response.data;
            this.total_users = this.data.length;
            if (this.total_users <= this.max_users){
              this.errorUser = null;
                  this.showModalUser = true;
            }else{
              this.errorUser = null;
                  //this.showModalMaxUser = true;
                  this.showModalUser = true;
            }
            this.$store.dispatch ("isLoadingOff");
          })
          .catch(() => {
            this.$store.dispatch ("isLoadingOff");
          });
      },
      OnDeleteContact ()
      {
        let self = this;
        if(self.is_primary){
          self.$dialog.alert({
            title: self.$t("primary_contact"),
            body: self.$t("primary_contact_delete_message"),
          }, { customClass: 'cd-dialog cd-dialog--danger' })
        }else{
          self.$dialog.confirm({
              title: self.$t("EliminarContacto"),
              body: self.$t("EliminarContactoText"),
              okText: self.$t("Eliminar"),
              cancelText: self.$t("Cancelar"),
            },
            { customClass: 'cd-dialog cd-dialog--danger' })
            .then(function() {
              if(self.users){
                /*self.$dialog.alert({
                  title: self.$t("primary_contact"),
                  body: self.$t("primary_contact_delete_message"),
                });*/
                Object.keys(self.users).forEach( key => {
                  //let value = JSON.stringify(self.users[key]);
                  let value = self.users[key];
                  Object.entries(value).forEach(([key, value]) => {
                    if (key === 'id'){
                      self.$axios.delete ("/user/" + value)
                          .then (() => {
                            self.fetch ();
                          });
                    }
                  });
                });
              }
                self.$axios.delete("/contacts/"+self.id)
                    .then(() =>{
                      self.$router.push('/admin/contacts');
                    })
                    .catch(() => {
                      self.$dialog.alert({
                        title: self.$t("EliminarContacto"),
                        body: self.$t("server_error")
                      }, { customClass: 'cd-dialog cd-dialog--danger' })
                    })

            })
        }
      },
      onLoadRequestTypes ()
      {
        this.$axios("/conf/services_types")
              .then((response) =>{
                  this.servicesTypes = response.data;
              })
      },
      onSearchAdrress ()
      {
        if(!this.address || !this.address.trim()) return;
        this.$store.dispatch('isLoadingOn');
        this.error_server = null;
        if(this.address.length >= 3){
          this.$axios("geolocation?search="+this.address)
          .then((response) => {
            let data = response.data.data.results;
            if(data.length > 0)
              this.onLoadAdrress(data);
            else
              this.error_server = this.$t("error_location");
            this.$store.dispatch('isLoadingOff');
          })
          .catch(() =>{
            this.$store.dispatch('isLoadingOff');
            this.error_server = this.$t("error_location");
          })
        }

      },
      onSendContract (id)
      {
        this.$store.dispatch('isLoadingOn');
        this.$axios.post( this.urlEmail + id)
          .then(() => {
            this.fetch();
            this.$store.dispatch('isLoadingOff');
            this.$dialog.alert({
                title: this.$t("send_contract"),
                body: this.$t("send_contract_complete")
            }, { customClass: 'cd-dialog cd-dialog--success' })
          })
          .catch(() => {
              this.$store.dispatch('isLoadingOff');
              this.$dialog.alert({
                    title: this.$t("send_contract"),
                    body: this.$t("server_error")
                }, { customClass: 'cd-dialog cd-dialog--danger' })
            })
      },
      onLoadAdrress (data)
      {
        let address_components = data[0].address_components
        this.full_address = data[0].formatted_address;
        for(let row in address_components){
          let section = address_components[row];
          switch (section.types[0]) {
            case 'locality':
              this.city = section.long_name;
              break;
            case 'postal_code':
              this.zipcode = section.long_name;
              break;
            case 'administrative_area_level_2':
              this.state = section.long_name;
              break;
          }

       }
      },
      onShowModal (item)
      {
        this.showModalUpload = true;
        this.files = null;
        this.item = item;
      },
      file_upload (event)
      {
        let files = event.target.files;
        let self = this;
        if (files.length > 0) {
            this.error = false;
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                self.files = {
                    name        : files[0].name,
                    file_type   : self.fileTypes[files[0].type],
                    image_64    : reader.result.split(',')[1]
                };
            };
          }
      },
      onUploadContract ()
      {
        this.$store.dispatch('isLoadingOn');
        this.$axios.post("/mediation/upload_contract/"+this.item.id, this.files)
          .then(() => {
            this.item = null;
            this.showModalUpload = false;
            this.fetch();
            this.$store.dispatch('isLoadingOff');
          })
          .catch((error) => {
            this.$store.dispatch('isLoadingOff');
            handleLimitError(this, error);
          })
      },
      file_reset ()
      {
        this.files = null
      },
      onEditUser (data)
      {
        
        this.checkedNodes = [];
        data.folders.forEach (item => {
          this.checkedNodes.push (String (item.folder_id));
        });
        // Users stored before INICIO became exclusive may carry the root along
        // with single folders: the root already covers them all.
        if (this.checkedNodes.includes (this.ROOT_FOLDER_ID)) this.checkedNodes = [this.ROOT_FOLDER_ID];
        this.getFolderChecked (this.checkedNodes);
        this.email_contact = data.email;
        this.name_user = data.name;
        this.rol_id = data.rol_id;
        this.active = data.active == 1 ? true : false;
        this.position = data.client_user.position;
        // The boxes start empty on every edit: filled in they change the password,
        // left alone they keep it.
        this.password = null;
        this.repassword = null;
        this.user_id = data.id;
        this.isNew = false;
        this.errorUser = null,
        this.showModalUser = true;
        //console.log ("this edit: ", this);
        //console.log ("data edit: ", data);
      },
      onCreateUser ()
      {

        if (!this.isAdminRole && this.checkedFolder.length == 0 && this.checkedNodes.length == 0){
          this.$dialog.alert ({
            title: this.userModalTitle,
            body: this.$t("asign_folder")
          }, { customClass: 'cd-dialog cd-dialog--warning' });
          this.$store.dispatch ('isLoadingOff');
          return;
        }

        if (this.validationsUser ())
        {
            this.$store.dispatch ('isLoadingOn');
            // An administrator is stored against the root (INICIO) so that the whole
            // tree is theirs, whatever the locked tree happens to hold.
            let nodes = this.isAdminRole
              ? [this.ROOT_FOLDER_ID]
              : (this.$refs.treeview ? this.$refs.treeview.ej2Instances.checkedNodes : this.checkedNodes);
            if (this.isNew)
            {
                let data = {
                      name      : this.name_user,
                      email     : this.email_contact,
                      rol_id    : this.rol_id,
                      position  : this.position,
                      active    : this.active,
                      password  : this.password,
                      repassword  : this.repassword,
                      contact_folders : nodes,
                      contact_id : this.id
                };
                //console.log ("this: ", this);
                //data.client_user.position = this.position;
              this.$axios.get("/user?where-email=" + this.email_contact)
                  .then((response) => {

                    const userExists = response.data && response.data.length > 0;

                    if (userExists) {
                      // Usuario encontrado → mostrar error
                      this.errorUser = this.$t("busy_user");
                      this.$store.dispatch('isLoadingOff');
                    } else {
                      // Usuario NO encontrado → guardar
                      this.onSaveUser(data);
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                    this.$store.dispatch('isLoadingOff');
                  });

            }
            else
            {

              if (!this.isAdminRole && nodes.length == 0){
                this.$dialog.alert ({
                  title: this.userModalTitle,
                  body: this.$t("asign_folder")
                }, { customClass: 'cd-dialog cd-dialog--warning' });
                this.$store.dispatch ('isLoadingOff');
              }else{
                let data = {
                  name      : this.name_user,
                  rol_id    : this.rol_id,
                  position  : this.position,
                  active    : this.active,
                  contact_folders : nodes,
                  id        : this.user_id
                };
                // Only travels when it was typed: the API leaves the stored password
                // alone when the field does not arrive.
                if (this.password) data.password = this.password;
                //console.log ("this2: ", this);
                //data.client_user.position = this.position;
                this.onSaveUser (data);
              }
            }
        }
      },
      onSaveUser (data)
      {

        let request;
        // Captured before the request resolves: the flag drives the confirmation copy.
        const isNewUser = this.isNew;
        if (this.isNew) request = this.$axios.post ("/client/user", data)
        else request = this.$axios.put ("/client/user/" + data.id, data)
                  
        request.then (() => {
              this.showModalUser = false;
              this.fetch (); 
              this.$dialog.alert ({
                  title: this.$t(isNewUser ? "create_user" : "edit_user"),
                  body: this.$t(isNewUser ? "msg_user_created" : "msg_user_updated")
              },
              { customClass: 'cd-dialog cd-dialog--success' });
              this.$store.dispatch ('isLoadingOff');
          })
          .catch ((error) => {
            this.$store.dispatch ('isLoadingOff');
            // The modal stays open, so nothing typed is lost if the limit is raised.
            handleLimitError (this, error);
          })
      },
      validationsUser ()
      {
        let validation = true;
        this.errorUser = null;

        if(!this.name_user || this.name_user == ""){
          validation = false;
          this.errorUser = this.$t("name_validation");
        }
        else if(!this.email_contact || this.email_contact == ""){
          validation = false;
          this.errorUser = this.$t("email_validation");
        }
        else if(!this.position || this.position == ""){
          validation = false;
          this.errorUser = this.$t("position_validation");
        }
        else if(this.isNew && !this.password){
          validation = false;
          this.errorUser = this.$t("password_validation");
        }
        else if(this.password && this.password.length < 8){
          validation = false;
          this.errorUser = this.$t("password_length");
        }else if(this.password && !this.repassword){
          validation = false;
          this.errorUser = this.$t("repassword_validation");
        }else if(this.repassword != this.password){
          validation = false;
          this.errorUser = this.$t("password_not_equals");
        }else if(this.isNew && !this.rol_id){
          validation = false;
          this.errorUser = this.$t("rol_id");
        }
        return validation;
      },
      onLoadFolders ()
      {
        this.$axios ("documents?where-document_type_id=1")
          .then ((response) => {
              this.folders = response.data;
              this.fields.dataSource = this.getParents (this.folders);
              this.show = true;
          })
      },
      getParents (data)
      {
        let keys = [];
        for (let row in data)
        {
          if (!keys.includes (data [row].parent_id)) keys.push (data [row].parent_id);
        }
        data.forEach ((item) => {
          if (keys.includes (item.id)) item.hasChild = true;
          item.icon = 'icon-svg icon-folder-filled folder-icon';
        });
        data.unshift ({ id: 0, name: 'INICIO', icon : 'icon-svg icon-folder-filled folder-icon', hasChild: true, expanded: true});
        return data;
      }
    }
  }

</script>
<style>
/* Note under the password pair of the user modal. Quiet: it explains a rule, it is
   not part of the form. */
.cd-user-password-hint {
  margin: -0.25rem 0 0.5rem;
  color: var(--cd-text-muted);
  font-size: 12px;
}
.modal-xlg{
    max-width: 1000px;
}
.modal-xlg .modal-content{
    min-height: 500px;
}
.table > thead > tr > th{
    color: #535353;
    padding: 15px 10px;
}
.table.table thead{
  /*background: #c7e1f8;*/
  padding: 15px;
}
.folder-icon{
    color: #eac559;
  }
.e-treeview .e-list-item.e-active > .e-text-content .e-list-text{
  color: #141414 !important;
  font-weight: bold;
}
.e-list-text{
  text-transform: uppercase;
}
  /* The grey override that used to live here (background: #5d5d5d on the
     checked frame) is gone: Syncfusion checkboxes now take the brand green
     app-wide from variations.scss, matching .cd-checkbox. */
  /* The folder tree no longer scrolls on its own. It used to be capped at
     400px with a permanent scrollbar (overflow: hidden scroll), so expanding
     a branch left two nested scrollbars in the modal: the tree's own one and
     the modal body's, which already scrolls through .cd-modal-body-tall. The
     tree now grows freely and the body is the single scrolling area. */
  /* .e-checkbox-wrapper, .e-css.e-checkbox-wrapper {
    pointer-events: none !important;
  } */

/* Directory area while the role is Administrator. The tree is still shown -- hiding it
   would make the modal jump when the role changes -- but it is dimmed and inert, so it
   reads as "nothing to do here" rather than as a tree that ignores clicks. The
   component's own `disabled` already blocks the interaction; pointer-events also covers
   the label and the checkboxes around it. */
.contentRoot--locked .e-treeview {
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}
.contentRoot--locked .control-label {
  color: var(--cd-text-muted, #6b7280);
}
/* Reason the tree is locked, right under the label so it is read before the tree. */
.cd-folder-tree-hint {
  display: flex;
  align-items: center;
  margin: 0 0 0.5rem;
  color: var(--cd-text-muted, #6b7280);
  font-size: 13px;
}
</style>
